import { useState } from "react";
import "./top-listing-headers.css";
import SearchFilterInput from "../../form-fields/search-filter-input";
import SimpleButton from "../../buttons/Simple-button";
import H2 from "../../typography/H2";
import { useNavigate } from "react-router";

interface ListingTopHeaderProps {
  PageHeading?: string;
  Count?: number;
  ButtonName?: string;
  MobileButtonName?: string;
  searchTerm: string;
  setSearchTerm: (term: string) => void; // Made non-optional
  onClick?: () => void;
  showAddButton?: boolean;
}

export default function PropertyTopHeader({
  PageHeading,
  Count,
  ButtonName,
  MobileButtonName,
  searchTerm,
  setSearchTerm,
  onClick,
  showAddButton = true,
}: ListingTopHeaderProps) {
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };


const navigateTo = useNavigate();

  const handleButtonClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigateTo("/properties/create");
    }
  };

  return (
    <div className="top-listing-headers">
      <div className="top-listing-header-main">
        <div className="top-listing-header-left">
          <H2 text={`${PageHeading}${Count !== undefined ? ` (${Count})` : ""}`} />
          {ButtonName && showAddButton && (
            <div className="top-listing-header-button-mobile">
              <SimpleButton label={MobileButtonName || ButtonName} onClick={handleButtonClick} />
            </div>
          )}
        </div>

        <div className="top-listing-header-right">
          <SearchFilterInput
            placeholder="Search By Address"
            searchTerm={searchTerm}
            handleSearch={handleSearch}
          />

          {ButtonName && showAddButton && (
            <div className="top-listing-header-button-desktop">
              <SimpleButton label={ButtonName} onClick={handleButtonClick} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}